<template>
    <div class="s-menu-pc">
        <v-navigation-drawer
            permanent
            :mini-variant="mini"
            class="s-menu-pc__navigation"
            width="300"
            fixed
        >
            <v-card
                width="100%"
                elevation="0"
                height="62"
                min-height="62"
                :max-width="mini ? '50' : '100%'"
                class="d-flex align-center justify-center pa-2 pl-1 pr-1 rounded-0"
            >
                <v-img
                    src="/imgs/logos/logo_small.png"
                    width="110"
                    max-width="110"
                ></v-img>
            </v-card>
            <v-list nav>
                <div
                    v-for="(option, index) in menu"
                    :key="index"
                >
                    <div v-if="option.submenu.length > 0">
                        <v-list-group
                            no-action
                            :ripple="false"
                            color="white"
                            v-if="!mini"
                            :class="(index+1)==menu.length ? '' : 'mb-2'"
                        >
                            <template v-slot:activator>
                                <v-list-item
                                    :ripple="false"
                                    class="ma-0 pl-0"
                                >
                                    <v-icon class="s-menu-pc__list-icon mr-2">{{option.icon}}</v-icon>
                                    <h1 class="app-private-menu-dark">{{option.title}}</h1>
                                </v-list-item>
                            </template>
                            <div
                                v-for="(child, subindex) in option.submenu"
                                :key="subindex"
                                class="pl-7"
                            >
                                <v-list-item
                                    :to="child.route"
                                    class="s-menu-pc__list-option"
                                    :ripple="false"
                                    active-class="s-menu-pc__list-option-activate"
                                >
                                    <v-icon class="s-menu-pc__list-icon mr-2">{{child.icon}}</v-icon>
                                    <h1 class="app-private-menu-dark">{{child.title}}</h1>
                                </v-list-item>
                            </div>
                        </v-list-group>
                        <v-menu
                            v-else
                            transition="slide-x-transition"
                            bottom
                            right
                            offset-x
                            z-index="60"
                            open-on-hover
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item
                                    :ripple="false"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="s-menu-pc__list-option"
                                >
                                    <v-icon class="s-menu-pc__list-icon">
                                        {{option.icon}}</v-icon>
                                </v-list-item>
                            </template>
                            <v-card class="pa-1">
                                <v-list-item
                                    v-for="(child, index) in option.submenu"
                                    :key="index"
                                    :to="child.route"
                                    class="s-menu-pc__menu-option"
                                    :ripple="false"
                                    active-class="s-menu-pc__menu-option-activate"
                                >
                                    <v-icon class="s-menu-pc__menu-icon mr-2">{{child.icon}}</v-icon>
                                    <h1 class="app-private-menu">{{child.title}}</h1>
                                </v-list-item>
                            </v-card>
                        </v-menu>
                    </div>
                    <div v-else>
                        <div v-if="mini">
                            <v-tooltip bottom color="#010d14">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-list-item
                                        v-bind="attrs"
                                        v-on="on"
                                        :to="option.route"
                                        :ripple="false"
                                        :class="(index+1) == menu.length
                                            ? 's-menu-pc__list-option'
                                            : 's-menu-pc__list-option mb-2'"
                                    >
                                        <v-icon class="s-menu-pc__list-icon">{{option.icon}}</v-icon>
                                    </v-list-item>
                                </template>
                                <div class="d-flex">
                                    <v-icon class="s-menu-pc__list-icon mr-2">mdi-hand-pointing-right</v-icon>
                                    <h1 class="app-private-menu-dark">{{option.title}}</h1>
                                </div>
                            </v-tooltip>
                        </div>
                        <v-list-item
                            v-else
                            :to="option.route"
                            :ripple="false"
                            :class="(index+1) == menu.length
                                ? 's-menu-pc__list-option'
                                : 's-menu-pc__list-option mb-2'"
                            active-class="s-menu-pc__list-option-activate"
                        >
                            <v-icon class="s-menu-pc__list-icon mr-2">{{option.icon}}</v-icon>
                            <h1 class="app-private-menu-dark">{{option.title}}</h1>
                        </v-list-item>
                    </div>
                </div>
                <v-list-item
                    :ripple="false"
                    @click="eCloseSesion()"
                    class="s-menu-pc__list-option mt-2"
                    active-class="s-menu-pc__list-option-activate"
                >
                    <v-icon class="s-menu-pc__list-icon mr-2">mdi-close</v-icon>
                    <h1 class="app-private-menu-dark">Cerrar Sesión</h1>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <CLoaderOperationComp
            :value="dialogLoaderOperation"
            smsOperation="Cerrando Sesión"
        />
    </div>
</template>
<script>
import { User } from "../../../models";
import { CLoaderOperationComp } from "../../../components/private/cells";
export default {
    components: {
        CLoaderOperationComp
    },
    props: {
        menu: Array,
        mini: Boolean
    },
    data: () => ({
        dialogLoaderOperation: false
    }),
    methods: {
        async eCloseSesion() {
            this.dialogLoaderOperation = true;
            try {
                await User.logout();
                this.dialogLoaderOperation = false;
                localStorage.removeItem("algis");
                setTimeout(() => {
                    this.$router.replace('/login');
                }, 150);
            } catch (error) {
                localStorage.removeItem("algis");
                this.$router.replace('/login');
            }
        },
    }
}
</script>